//import {APPLYOO} from "../applyoo";

// import {applyoo} from "../../App";

import {ApplyooNS} from "../applyooConstants";

export interface IApplyooEventListener {
    triggerName:string,
    lstEventTypes:[eSystemEvents],
    metadata?: any,
    callback?:IFireApplyooEvent,
    lstActions?:any,
    lstConditions?:any,
    isPageTrigger:boolean,
}

export interface IFireApplyooEvent {
    eventType: eSystemEvents,
    metadata?: any,
    responseObj?: any
}

export enum eSystemEvents {
    AfterGetPage = "afterGetPage",
    BeforeGetPage = "beforeGetPage",

    BeforeGetRepositoryItems = "beforeGetRepositoryItems",
    AfterGetRepositoryItems = "afterGetRepositoryItems",

    BeforeRenderUIElements = "beforeRenderUIElements",
    AfterRenderUIElements = "afterRenderUIElements",

    BeforeSave = "beforeSave",
    AfterSave_Succeed = "afterSave_Succeed",
    AfterSave_Failed = "afterSave_Failed",

    AfterGetPageData_BeforeRefreshElements = "afterGetPageData_BeforeRefreshElements",

    OnBeforeSave_CheckDataValidation = "onBeforeSave_CheckDataValidation",
    OnDataValidationFail = "onDataValidationFail",
    OnDataValidationSucceed = "onDataValidationSucceed",

}
// enum eApplyooEvent {
//     beforeGetRepositoryItems = "beforeGetRepositoryItems",
//     afterGetRepositoryItems = "afterGetRepositoryItems",
//     beforeRenderUIElements = "afterRenderUIElements",
//     newDataRow = "newDataRow",
//     pageDataChanged = "pageDataChanged",
//     beforeSave = "beforeSave",
//     afterSave_Succeed = "afterSave_Succeed",
//     afterSave_Failed = "afterSave_Failed",
// }

let actionsManager:any = null

const getNewGuid = () => {
    // @ts-ignore
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

//LstEventTypes:[eApplyooEvent], prmMetadata?:any
export const unsubscribeEvent = (prmEventListenerGuid:string) => {

}

export const unsubscribeAllPageEvents = (prmEventListenerGuid:string) => {

}

export const subscribeEvent = (prmEventListenerParams:IApplyooEventListener) => {
    const outEventListenerGuid:string = getNewGuid()

    //APPLYOO.dicEventListeners[outEventListenerGuid] = {...prmEventListenerParams}
    ApplyooNS.dicEventListeners[prmEventListenerParams.triggerName] = {...prmEventListenerParams}

    return outEventListenerGuid;
}

export const fireApplyooEvent = (prmEventObj:IFireApplyooEvent) => {
    for (const currEventListenerGuid in ApplyooNS.dicEventListeners) {

        let currEventListener = ApplyooNS.dicEventListeners[currEventListenerGuid];

        if (currEventListener.lstEventTypes.includes(prmEventObj.eventType)){
            if (!currEventListener.metadata){
                if (!!currEventListener.callback){
                    currEventListener.callback(prmEventObj)
                }

                if (!!actionsManager
                    && !!currEventListener.lstActions
                    && currEventListener.lstActions.length > 0){
                    actionsManager?.executeActions(currEventListener.lstActions)
                }
            }
        }
    }
}

export const loadPageTriggers = (prmPageInfo: any,prmActionsManager:any) => {
    //this.dicTriggersByCondition = {};
    actionsManager=prmActionsManager;
    ApplyooNS.dicEventListeners = {};

    if (prmPageInfo?.PageProperties?.TriggersObj){
        let lstPageTriggers = JSON.parse(prmPageInfo?.PageProperties?.TriggersObj);

        for (const currTrigger of lstPageTriggers) {
            if (!!currTrigger.isActive){
                for (const currCondition of currTrigger.conditions) {
                    let pageTrigger:IApplyooEventListener = {
                        triggerName: currTrigger.name,
                        lstEventTypes:[currCondition.itemID],
                        lstConditions: currTrigger.conditions,
                        //metadata: any,
                        //callback:IFireApplyooEvent,
                        lstActions:currTrigger.actions,
                        isPageTrigger:true
                    }

                    subscribeEvent(pageTrigger)
                }
            }
        }

        // for (let ind01 = 0; ind01 < lstPageTriggers.length; ind01++) {
        //     let currTrigger = lstPageTriggers[ind01];
        //
        //     if (!currTrigger.isActive) {continue}
        //
        //     for (let ind02 = 0; ind02 < currTrigger.conditions.length; ind02++) {
        //         let currCondition =  currTrigger.conditions[ind02];
        //
        //         // if (!this.dicTriggersByCondition.hasOwnProperty(currCondition.itemID)){
        //         //     // @ts-ignore
        //         //     this.dicTriggersByCondition[currCondition.itemID] = {
        //         //         eventTypeID: currCondition.itemID,
        //         //         value:null,
        //         //         lstActions: currTrigger.actions,
        //         //         dicSubscribers: {},
        //         //     };
        //         // }
        //
        //     }
        //
        // }
    }
}